export default {
  notifications: {
    message: {
      system: "{name} vous a envoyé une notification",
      pass_approval_requested: "{name} a soumis une demande de pass à valider",
      // A decision names its visitor, appended as « · Karim » (filled with
      // the separator, empty when the guest row is gone): « Tout valider » on
      // a group of three sends three lines, which must not read the same. A
      // suffix rather than « la demande de {guest} » for guest_arrived's
      // reason — « de Amine » cannot elide to « d'Amine ».
      pass_approved: "{name} a validé votre demande de pass{guest}",
      pass_rejected: "{name} a refusé votre demande de pass{guest}",
      // The doorbell names the visitor and the unit, not the actor — the
      // résident has two seconds and the gardien's name isn't the point.
      spot_arrival_requested: "{visitor} se présente pour {unit} — autoriser ?",
      // Same reasoning, and gender-neutral by construction: the label form
      // sidesteps the arrivé/arrivée agreement a visitor's name cannot
      // settle. A colon, not « Arrivée de », because the elision no
      // interpolation can do (« Arrivée de Amine » → « d'Amine ») would be
      // wrong for every vowel-initial name.
      guest_arrived: "Arrivée : {guest} · {unit}",
      // Self-fill (spec 2026-09-23 §6): subject-shaped, like guest_arrived —
      // the host wants to know WHICH visitor, and the actor is the host.
      guest_completed: "{guest} a complété ses informations",
      // Colis. Subject-shaped like the doorbell: what matters in a
      // two-second glance is the parcel and the unit, not the gardien.
      // `{desk}` is filled from Terms (« à la loge » / « à l'accueil »), so
      // one template serves both verticals; `{days}` is the parcel's real
      // age at send time, not the 3-day constant — a sweep that ran late
      // must not claim three days when five have passed.
      parcel_received: "Un colis vous attend {desk} · {unit}",
      parcel_reminder: "Votre colis attend {desk} depuis {days} jours · {unit}",
      parcel_handed_over: "Colis remis {collector} · {unit}",
      // Réservation d'amenity. Subject-shaped like the colis lines: the
      // amenity's name, the day and the hours are what the résident reads in
      // two seconds. `{bookingDay}` (no hours) is used for the refusal, since
      // the hours no longer matter once the créneau is refused; `{reason}`
      // carries the gardien/admin's typed motif, parenthesised upstream.
      booking_requested: "{actor} demande {booking}",
      booking_confirmed: "Réservation confirmée · {booking}",
      booking_rejected: "Réservation refusée · {bookingDay}{reason}",
      booking_cancelled: "Réservation annulée · {booking}",
      booking_reminder: "Bientôt : {booking}",
    },
    // Inbox-only overrides. The push line is read within seconds; the inbox
    // row is read days later, as history. Only the doorbell differs: its push
    // is a question with a 45-second clock (« — autoriser ? »), which a
    // settled arrival must not keep asking. Every other type reads the same
    // on both surfaces and needs no entry here.
    inbox: {
      spot_arrival_requested: "Arrivée imprévue : {visitor} · {unit}",
    },
  },
} as const;
